import request from './request'
import {TOTAL_MARKET,MAN_RANK,CATEGORY_MARKET, SEGMENT_MARKET,COUNTRY_MARKET,FUEL_MARKET} from '../utils/constant'

export function getTotalMarketData(type){
    return request({
        url:"/chartlist",
        params:{
           type:type,
           charttype:TOTAL_MARKET 
        }
    })
}


export function getManRankData(type){
    return request({
        url:"/chartlist",
        params:{
           type:type,
           charttype:MAN_RANK 
        }
    })
}

export function getManRankData_Retail(type){
    return request({
        url:"/chartlist_2",
        params:{
           type:type,
           charttype:MAN_RANK 
        }
    })
}


export function getCategoryMarketData(type){
    return request({
        url:"/chartlist",
        params:{
           type:type,
           charttype:CATEGORY_MARKET 
        }
    })
}

export function getCountryMarketData(type){
    return request({
        url:"/chartlist",
        params:{
           type:type,
           charttype:COUNTRY_MARKET 
        }
    })
}

export function getSegmentMarketData(type){
    return request({
        url:"/chartlist",
        params:{
           type:type,
           charttype:SEGMENT_MARKET 
        }
    })
}

export function getFuelMarketData(type){
    return request({
        url:"/chartlist",
        params:{
           type:type,
           charttype:FUEL_MARKET 
        }
    })
}